import { InsuranceProgramFragment, PassengerSelectedGdsServicesFragment } from '@websky/graphql';
import { PassengerService, ServiceDescription } from '@widgets/upsale/lib/types';

export const isInsuranceGuard = (
	service: PassengerService | ServiceDescription
): service is InsuranceProgramFragment => {
	return !!(service as InsuranceProgramFragment).code;
};

export const isGdsServiceGuard = (service: PassengerService): service is PassengerSelectedGdsServicesFragment => {
	return 'confirmedCount' in (service as PassengerSelectedGdsServicesFragment);
};
